export default __webpack_public_path__ + "static/savings-bee-d26832ef536b03184d2a8710064bcf4f.png";